import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/** Processes Emergent OAuth session_id from URL fragment, calls backend to establish session, routes user. */
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/login", { replace: true }); return; }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        // Clean the hash from URL
        window.history.replaceState(null, "", window.location.pathname);
        setUser(data);
        if (data.status === "pending") {
          nav("/awaiting-approval", { replace: true, state: { email: data.email, name: data.full_name } });
        } else if (data.status === "rejected") {
          nav("/login", { replace: true, state: { rejected: true } });
        } else if (data.role === "admin" || data.role === "super_admin") {
          nav("/admin", { replace: true });
        } else {
          nav("/dashboard", { replace: true });
        }
      } catch (err) {
        setError(errorMessage(err));
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="overline mb-3">Signing you in</div>
        <div className="font-display font-black text-2xl tracking-tight">Connecting to Steadfast...</div>
        {error && (
          <div className="mt-6 text-[13px] text-destructive max-w-sm mx-auto">{error}</div>
        )}
      </div>
    </div>
  );
}
